import { Component } from "@angular/core";

@Component({
  selector: "app-footer",
  template: `
    <div class="layout-footer">
      <div class="logo-text flex justify-content-start align-items-center">
        <img
          src="assets/layout/images/logo/logo.png"
          alt="Vetportal"
          style="height: auto; width: 100px"
        />
        <div class="text ml-2">
          <span>Version: 2.3.0</span>
        </div>
      </div>
      <div class="icons">
        <!-- <div class="icon icon-hastag">
					<i class="pi pi-home"></i>
				</div>
				<div class="icon icon-twitter">
					<i class="pi pi-globe"></i>
				</div>
				<div class="icon icon-prime">
					<i class="pi pi-bookmark"></i>
				</div> -->
      </div>
    </div>
  `,
})
export class AppFooterComponent {}
